export default __webpack_public_path__ + "static/media/gp.30b1d26c.svg";